import type { RegionalNurseryDistributionResponse } from '~/apis/analyticsChartsApi';

export const CHART_ALL_YEARS = 'all';

export const CHART_COLORS = {
  forestGreen: '#1B4332',
  gold: '#B58D3D',
  pending: '#ed6c02',
  underReview: '#f9a825',
  approved: '#1B4332',
  rejected: '#d32f2f',
  cn02: '#1B4332',
  cn03: '#4caf50',
  cn04: '#00897b',
  cn05: '#1976d2',
  cn06: '#7b1fa2',
  inspector: '#2D8A4E',
} as const;

export function currentCalendarYear(): number {
  return new Date().getFullYear();
}

export function buildChartYearOptions(): { value: string; label: string }[] {
  const current = currentCalendarYear();
  const years: { value: string; label: string }[] = [
    { value: CHART_ALL_YEARS, label: 'All Years' },
  ];
  for (let year = 2019; year <= current; year += 1) {
    years.push({ value: String(year), label: String(year) });
  }
  return years;
}

export const CHART_YEAR_OPTIONS = buildChartYearOptions();

export type FlattenedDistrictRow = {
  districtName: string;
  applicationsSubmitted: number;
  permitsIssued: number;
};

export function flattenRegionalDistricts(
  data: RegionalNurseryDistributionResponse | null
): FlattenedDistrictRow[] {
  if (!data?.items?.length) return [];
  return data.items.flatMap((region) =>
    (region.districts ?? []).map((district) => ({
      districtName: district.districtName,
      applicationsSubmitted: district.applicationsSubmitted,
      permitsIssued: district.permitsIssued,
    }))
  );
}

export function formatChartTooltipValue(value: unknown): string {
  const num = typeof value === 'number' ? value : Number(value ?? 0);
  return Number.isFinite(num) ? num.toLocaleString() : '0';
}

export function parseChartYearFilter(value: string): number | undefined {
  if (!value || value === CHART_ALL_YEARS) return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}
